import { useEffect } from 'react'

const MessageContentHead = ({
  name
}) =>
{
  return (
    <div className="message-content-head">
      <h3>{ name }</h3>
    </div>
  )
}

export default MessageContentHead
